import { data, redirect, type LoaderFunctionArgs } from 'react-router';
import { estSessionIndisponible } from '../../api/errors.js';
import type { SessionUtilisateur } from '../../api/types.js';
import { cheminConditions } from '../../auth/cgu.js';
import { adresseDeRetour, retourSur } from '../../auth/retour.js';
import { chargerSession } from '../../auth/session.js';
import { RAISON_HORS_LIGNE } from '../loaders.js';

export interface DonneesDoubleAuthentification {
  readonly session: SessionUtilisateur;
  /** Où revenir une fois la double authentification activée, assaini (`auth/retour.ts`). */
  readonly retour: string;
}

/**
 * `/app/double-authentification` : la session est exigée et TOUJOURS relue,
 * sans repli hors ligne — on ne s'enrôle pas sans le serveur. Les CGU passent
 * d'abord (l'API refuse l'enrôlement tant qu'elles sont à accepter) ; un
 * compte déjà enrôlé repart vers son retour.
 */
export async function doubleAuthentificationLoader({
  request,
}: LoaderFunctionArgs): Promise<DonneesDoubleAuthentification> {
  const retour = retourSur(new URL(request.url).searchParams.get('retour'));
  let session: SessionUtilisateur;
  try {
    session = await chargerSession(null);
  } catch (erreur) {
    if (estSessionIndisponible(erreur)) throw data({ raison: RAISON_HORS_LIGNE }, { status: 503 });
    throw redirect(`/connexion?retour=${encodeURIComponent(adresseDeRetour(request.url))}`);
  }
  if (session.cguAcceptationRequise) throw redirect(cheminConditions(adresseDeRetour(request.url)));
  if (session.compte.deuxiemeFacteurActive) throw redirect(retour);
  return { session, retour };
}
